export const SELL_VIDEO_URL = 'https://ik.imagekit.io/ydhpl3nen/whole-video-3.mp4?updatedAt=1740224677404';
export const BUY_VIDEO_URL = 'https://ik.imagekit.io/ydhpl3nen/whole-second-video.mp4?updatedAt=1740224647709';
